module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/governmentForms/Attachment.ejs -->\n<div class="ibox float-e-margins govt-form-item\n    '+
((__t=( model.hasTag('period-' + (new Date()).getFullYear()) ?
        'current' : '' ))==null?'':_.escape(__t))+
'">\n    <div class="ibox-title">\n        <h2>\n            '+
((__t=( model.get('description') ))==null?'':_.escape(__t))+
'\n            '+
((__t=( (model.findTag(/^period-\d{4}$/) || '').substr(-4) ))==null?'':_.escape(__t))+
'\n            <span class="small">\n                ('+
((__t=( model.get('name') ))==null?'':_.escape(__t))+
')\n            </span>\n        </h2>\n    </div>\n    <div class="ibox-content">\n        <div class="row '+
((__t=( showDelete ? 'text-right' : 'text-center' ))==null?'':_.escape(__t))+
'">\n            <div class="col-xs-12 clearfix">\n                ';
 if (showDelete) { 
__p+='\n                <button class="btn btn-outline btn-danger js-destroy\n                    float-left">\n                    <i class="fa fa-trash"></i>\n                    Delete\n                </button>\n                ';
 } 
__p+='\n\n                <!-- Display icon based on the extension of attachment -->\n                ';
 icon = model.getUrl().includes('.pdf') ? 'fa-file-pdf-o' : 'fa-file-excel-o' 
__p+='\n                <a class="btn btn-outline btn-primary js-download"\n                    href="'+
((__t=( model.downloadUrl() ))==null?'':_.escape(__t))+
'" target="_blank">\n                    <i class="fa '+
((__t=( icon ))==null?'':_.escape(__t))+
'"></i>\n                    Download\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/governmentForms/Attachment.ejs
// module id = 916
// module chunks = 1